import {
  createDefaultContentJson,
  createDefaultLayoutJson,
  formatBulkFieldFromTranslations,
  normalizeContentJson,
  normalizeLayoutJson,
} from './ads/adLayoutDefaults';

function text(value, fallback = '') {
  const s = String(value ?? '').trim();
  return s || fallback;
}

export function createDefaultInfoCardContent(highlightPoint = '', highlightMessage = '') {
  const base = createDefaultContentJson('main');
  const ko = {
    badgeTop: 'EVENT',
    badgeBottom: 'HIGHLIGHT',
    title: text(highlightPoint, '오늘의 기회!'),
    titleAccent: '',
    reward: '',
    description: text(highlightMessage, '이벤트 안내를 확인하세요.'),
    buttonText: '확인',
  };
  const en = {
    badgeTop: 'EVENT',
    badgeBottom: 'HIGHLIGHT',
    title: 'TODAY EVENT',
    titleAccent: '',
    reward: '',
    description: 'Check the latest table event information.',
    buttonText: 'VIEW',
  };
  const translations = { ...base.translations, ko, en };
  const bulkFields = { ...base.bulkFields };
  Object.keys(ko).forEach((key) => {
    bulkFields[key] = formatBulkFieldFromTranslations(translations, key);
  });
  return normalizeContentJson({ ...base, translations, bulkFields });
}

export const INFO_CARD_PROFILE_OPTIONS = {
  desktop: [
    { value: 'standard', label: 'Event Card 1 · 696×58' },
    { value: 'compact', label: 'Event Card 2+ · 696×56' },
  ],
  mobile: [
    { value: 'portrait', label: 'Mobile Event · 355×64' },
    { value: 'tablet', label: 'Tablet Event · 732×64' },
  ],
};

const INFO_CARD_CANVAS = {
  desktop: {
    standard: { width: 696, height: 58 },
    compact: { width: 696, height: 56 },
    // generic layout compatibility branch; event cards currently render standard/compact only.
    ultra: { width: 696, height: 56 },
  },
  mobile: {
    portrait: { width: 355, height: 64 },
    tablet: { width: 732, height: 64 },
  },
};

export function normalizeInfoCardLayout(value) {
  const layout = normalizeLayoutJson(value);
  const next = {
    ...layout,
    desktop: { ...layout.desktop },
    mobile: { ...layout.mobile },
  };

  Object.entries(INFO_CARD_CANVAS).forEach(([family, profiles]) => {
    Object.entries(profiles).forEach(([profile, canvas]) => {
      const branch = next?.[family]?.[profile] || {};
      next[family][profile] = { ...branch, canvas: { ...canvas } };
    });
  });

  return next;
}

export function createDefaultInfoCardLayout() {
  return normalizeInfoCardLayout(createDefaultLayoutJson('main'));
}

export function createDefaultInfoCardDesign(highlightPoint = '', highlightMessage = '') {
  return {
    enabled: true,
    templateKey: 'FREEFORM_V1',
    backgroundMode: 'COVER',
    imageUrl: '', // legacy/default desktop fallback
    desktopImageUrl: '',
    mobileImageUrl: '',
    contentJson: createDefaultInfoCardContent(highlightPoint, highlightMessage),
    layoutJson: createDefaultInfoCardLayout(),
  };
}

export function normalizeInfoCardDesign(value, highlightPoint = '', highlightMessage = '') {
  const defaults = createDefaultInfoCardDesign(highlightPoint, highlightMessage);
  const input = value && typeof value === 'object' && !Array.isArray(value) ? value : {};
  const legacyImageUrl = String(input.imageUrl || input.image_url || '');
  const desktopImageUrl = String(input.desktopImageUrl || input.desktop_image_url || legacyImageUrl || '');
  const mobileImageUrl = String(input.mobileImageUrl || input.mobile_image_url || '');
  return {
    enabled: input.enabled !== false,
    templateKey: String(input.templateKey || input.template_key || defaults.templateKey).toUpperCase(),
    backgroundMode: String(input.backgroundMode || input.background_mode || defaults.backgroundMode).toUpperCase(),
    imageUrl: legacyImageUrl || desktopImageUrl,
    desktopImageUrl,
    mobileImageUrl,
    contentJson: normalizeContentJson(input.contentJson || input.content_json || defaults.contentJson),
    layoutJson: normalizeInfoCardLayout(input.layoutJson || input.layout_json || defaults.layoutJson),
  };
}
